import React from 'react';
import analytics from '../../../modules/analytics';
import useRouteName from '../../../hooks/useRouteName';
import InsightsCTAs from './InsightsCTAs';
import { useLinkTo } from '../../../hooks';
import { PRO_TODAY_TAB_HOME } from '../../../route-names';

type InsightsCTAsContainerProps = {
  providerId: number
};

export const InsightsCTAsContainer = ({
  providerId,
}: InsightsCTAsContainerProps) => {
  const linkTo = useLinkTo();
  const [routeName] = useRouteName();
  const isHomeTab = routeName === PRO_TODAY_TAB_HOME;
  const handleCtaPress = ({
    cta, event, options,
  }: {
    cta: string,
    event: string,
    options: object
  }) => {
    analytics.track(event);
    linkTo(cta, options);
  };
  return (
    <InsightsCTAs
      handleCtaPress={handleCtaPress}
      providerId={providerId}
      isHomeTab={isHomeTab}
    />
  );
};

export default InsightsCTAsContainer;
